export default [
    {
        path: '/dataList/staffBorrowInfo',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '店员借领',
            authLogin: true
        }
    },   
];